import * as React from "react";
import styled from "styled-components";
import defaultTheme from "../../defaultTheme";
import ButtonLink from "../../ButtonLink";
var StyledOnlyButton = styled(ButtonLink).withConfig({
  displayName: "FilterWrapper__StyledOnlyButton",
  componentId: "sc-1cpg3jn-0"
})([""]);
var StyledContentWrapper = styled.div.withConfig({
  displayName: "FilterWrapper__StyledContentWrapper",
  componentId: "sc-1cpg3jn-1"
})(["width:100%;padding:0px 4px;border-radius:4px;display:flex;align-items:center;&:hover,&:focus-within{background-color:", ";", "{visibility:visible;opacity:1;}}", "{visibility:hidden;opacity:0;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.orbit.paletteProductLight;
}, StyledOnlyButton, StyledOnlyButton);
StyledContentWrapper.defaultProps = {
  theme: defaultTheme
};

var FilterWrapper = function FilterWrapper(_ref2) {
  var child = _ref2.child,
      children = _ref2.children,
      onOnlySelection = _ref2.onOnlySelection;
  return React.createElement(StyledContentWrapper, null, children, onOnlySelection && React.createElement(StyledOnlyButton, {
    type: "secondary",
    size: "small",
    onClick: function onClick(ev) {
      onOnlySelection(ev, {
        value: child.props.value,
        label: child.props.label
      });
    },
    transparent: true
  }, "Only "));
};

export default FilterWrapper;